<div class="desktop-step-one desktop-filter-step">
  <div class="desktop-filter-step__side-by-side">
    <div class="desktop-filter-step__card">
      <div class="desktop-filter-step__row">
        <lib-contract-type-switch
          [currentOption]="filterState.contractType.filter"
          [options]="filterState.contractType.options"
          (update)="onContractTypeChange($event)"
          class="full-width"
        >
        </lib-contract-type-switch>
      </div>

      <div class="desktop-filter-step__row">
        <div class="desktop-step-one__region-top">
          <div class="desktop-step-one__region-title">
            {{ 'searchSubscription.location' | i18n }}
            <ng-container *ngIf="regions.length < 2">{{
              'searchSubscription.andRadius' | i18n
            }}</ng-container>
          </div>

          <button
            class="desktop-step-one__reset-chips"
            *ngIf="regions.length > 0"
            (click)="resetAllRegions()"
          >
            {{ 'filters.common.reset' | i18n }}
          </button>
        </div>

        <lib-search-box
          placeholderText="searchSubscription.search.label"
          [radiusOptions]="radiusOptions"
          [forceHideRadius]="false"
          [disableReset]="true"
          [withChips]="false"
        >
        </lib-search-box>

        <div class="desktop-step-one__chips" *ngIf="regions.length > 0">
          <ul class="desktop-step-one__chip-list">
            <li
              class="desktop-step-one__chip-item"
              *ngFor="let region of regions; trackBy: trackByRegion"
            >
              <lib-removable-chip (remove)="removeRegionFilter(region)">
                {{ region.name }}
              </lib-removable-chip>
            </li>
          </ul>
        </div>
      </div>

      <div class="desktop-filter-step__row">
        <lib-category-filter
          (update)="onCategoryChange($event)"
        ></lib-category-filter>

        <div
          class="desktop-step-one__subcategory"
          *ngIf="displaySubcategory"
          [class.desktop-step-one__subcategory--visible]="isCategoryActive"
        >
          <lib-subcategory-filter
            [visibleCount]="3"
            [categoryFilter]="filterState.category.main.filter"
            (update)="onSubcategoryChange($event)"
          ></lib-subcategory-filter>
        </div>
      </div>
    </div>

    <div class="desktop-filter-step__chips">
      <h4 class="desktop-filter-step__chips-title">
        {{ 'searchSubscription.yourSearchCriteria' | i18n }}
      </h4>

      <lib-filter-chips [alwaysOpen]="true"></lib-filter-chips>
    </div>
  </div>
</div>
